import AdminAPIClient from '@/domain/repository/admin_api_client'
import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { AdminAPIClientKey } from './symbols'

axios.defaults.baseURL = 'https://d3okmk048eqfsj.cloudfront.net';
// axios.defaults.baseURL = 'http://localhost:8081';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
const adminAPIClient = new AdminAPIClient(axios)

createApp(App)
  .use(router)
  .provide(AdminAPIClientKey, adminAPIClient)
  .mount('#app')
